import { useMainLibStore } from "@innoclouds/shared";
import i18next from "i18next";
import constants from "../constants/constants";

const getOrgUnitId = async (orgUnitId: string) => {
	try {
		if (orgUnitId === undefined) return;

		const defaultLanguage = localStorage.getItem("default_language");

		const headers = new Headers();
		headers.set("Accept-Language", localStorage.getItem("locale") || defaultLanguage || i18next.language);

		const domain = import.meta?.env?.MODE !== "https" ? import.meta.env.VITE_API_URL : "";
		const response = await fetch(`${domain}/api/org/org-unit/${orgUnitId}/`, { headers });

		if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

		const data = await response.json();
		constants.value.orgId = data.organization;
		constants.value.pointId = data.id;
		constants.value.currency_symbol = data.currency_symbol;
		constants.value.default_language = data.default_language;
		constants.value.has_loyalty_default_user = data.has_loyalty_default_user;
		constants.value.loyalty = data.loyalty;
		constants.value.infinite_feed_qr = data.infinite_feed_qr;
		constants.value.qr_enable_flat_product_feed = data.qr_enable_flat_product_feed;
		constants.value.name = data.name;
		constants.value.quick_add_simple = data.quick_add_simple;
		constants.value.supported_languages = data.supported_languages;
		constants.value.kiosk_order_minimum_price = data.kiosk_order_minimum_price;
		constants.value.qr_order_minimum_price = data.qr_order_minimum_price;
		constants.value.enable_sequential_modifiers = data.enable_sequential_modifiers;
		constants.value.default_table = data.default_table;
		constants.value.is_hidden = data.is_hidden;
		constants.value.default_country_code = data.default_country_code;
		constants.value.order_item_comment_suggestions = data.order_item_comment_suggestions || null;
		constants.value.reserve_enabled = data.reserve_enabled;
		constants.value.display_likes = data.display_likes === true || data.display_likes === "true";

		const mainLibStore = useMainLibStore();
		if (mainLibStore.config_lib) mainLibStore.config_lib.display_likes = constants.value.display_likes;

		localStorage.setItem("default_language", data.default_language);
		if (!defaultLanguage || defaultLanguage !== data.default_language) i18next.changeLanguage(data.default_language);

		return data;
	} catch (error) {
		console.error("Ошибка в getOrgUnitId:", error);
		throw error;
	}
};

export default getOrgUnitId;
